import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language: any;
  supportedLanguage = environment.supported_language;
  private readonly _participantLocaleSubject = new BehaviorSubject<any>('de-DE');  
  public participantLanguage = new BehaviorSubject<any>(environment.supported_language[1]);
  public shareParticipantLanguage = this.participantLanguage.asObservable();
  isNotparticipantSelectedLang:boolean = false;

  private readonly showLanguageSelectionPageSubject = new BehaviorSubject<boolean>(false);
  public showLanguageSelectionPage$ = this.showLanguageSelectionPageSubject.asObservable();


  /**
   * @description This function is called from all routes and gives the user selected language from URL
   * Suppose, the user is in /register screen then the user will not have a language, in that case pick browser language
   * If language is present in URL
   * @returns language code
   */
  public getLanguage(): string {
    let defaultBrowserLanguage = navigator.language;
    let selectedLanguage:any = localStorage.getItem('language') ?? 'en-GB'; //languageId will get from url
    const currentUrl = window.location.href;

    const hasUserChangedLanguage = localStorage.getItem('languagePicked') === 'true';

     if (currentUrl.includes('/register') && !hasUserChangedLanguage) {
      defaultBrowserLanguage = defaultBrowserLanguage.split('-')[0]
      selectedLanguage = defaultBrowserLanguage;
    }

    const languageRegex: RegExp=/^[a-z]{2}-[A-Z]{2}$/

     const supportedLocales: any = {
      'en': 'en-GB',
      'de': 'de-DE',
      'fr': 'fr-FR',
      'it': 'it-IT',
      'ko': 'ko-KR',
      'cs': 'cs-CZ',
      'es': 'es-ES',
      'hr': 'hr-HR',
      'da': 'da-DK',
      'nl': 'nl-NL',
      'fi': 'fi-FI',
      'el': 'el-GR',
      'pl':'pl-PL',
      'ro': 'ro-RO',
      'sk' :'sk-SK',

    }

    if(languageRegex.test(selectedLanguage)) { //en-GB, //de-DE
      this.language = selectedLanguage;
    } else if(defaultBrowserLanguage && Object.keys(supportedLocales).includes(defaultBrowserLanguage)) { //system lang
      const selectedLang = (lang: string) => supportedLocales[lang];
      this.language = selectedLang(defaultBrowserLanguage);
    } else {
      this.language = environment.supported_language[0];  //en-GB
    }
    this._participantLocaleSubject.next(this.language);
    return this.language;
  }

  
  public set participantLocale(locale : string) {
    this._participantLocaleSubject.next(locale);
  }

  
  public get participantLocale() : any {
    return this._participantLocaleSubject.asObservable();
  }

  getDefaultLanguage() {
    const selectedLanguage = localStorage.getItem('language');
    const defaultBrowserLanguage = navigator.language;
    if(selectedLanguage && this.supportedLanguage.includes(selectedLanguage)) {
      this.language = selectedLanguage;
    } else if(defaultBrowserLanguage && this.supportedLanguage.includes(defaultBrowserLanguage)) {
      this.language = defaultBrowserLanguage;
    } else {
      this.language = environment.supported_language[0];
    }
    return this.language;
  }

  setParticipantLanguage(languageId: string) {
    this.participantLanguage.next(languageId);
  }

  setIsNotParticipantSelectedLang(status: boolean) {
    this.isNotparticipantSelectedLang = status;
  }
  getIsNotParticipantSelectedLang() {
    return this.isNotparticipantSelectedLang;
  }

  /**
   * @description This method is used to check the language is valid or not
   * Match the pattern of language en-GB, en-IN, de-DE, fr-FR, it-IT, es-ES, cs-CZ, ko-KR
   * @param locale 
   * @returns 
   */
  public checkIsValideLanguage(locale: any): boolean {
    const languageRegex: RegExp = /^[a-z]{2}-[A-Z]{2}$/;
    const isValid = languageRegex.test(locale);
    return isValid;
  }  

  public showLanguageSelectionPage(showLangPage: boolean){
    this.showLanguageSelectionPageSubject.next(showLangPage);
  }
  
}
